import { createAddUserModal } from 'features/add-user';
import { createBlockUserModal } from 'features/block-user';
import { createDeleteUserModal } from 'features/delete-user';
import { createEditUserModal } from 'features/edit-user';
import { createUnblockUserModal } from 'features/unblock-user';
import { createUserRegistry } from 'entities/user';
import { accountPageUsersModel } from '../../model';
import cls from './account-page-tab-users.module.scss';

const UserRegistry = createUserRegistry(accountPageUsersModel.userRegistryModel);

const AddUserModal = createAddUserModal(accountPageUsersModel.addUserModel);

const EditUserModal = createEditUserModal(accountPageUsersModel.editUserModel);

const BlockUserModal = createBlockUserModal(accountPageUsersModel.blockUserModel);

const UnblockUserModal = createUnblockUserModal(accountPageUsersModel.unblockUserModel);

const DeleteUserModal = createDeleteUserModal(accountPageUsersModel.deleteUserModel);

export const AccountPageTabUsers = () => (
	<>
		<UserRegistry
			withTitle={false}
			withAccount={false}
			className={cls.accountPageTabUsersUserRegistry}
			emptyActionSlot={<AddUserModal.Button />}
			topBarActionSlot={<AddUserModal.Button />}
			tableTdActionSlot={(user) => (
				<div className={cls.accountPageTabUsersActions}>
					<EditUserModal.ActionIcon modalData={user} />
					{user.isLocked ? (
						<UnblockUserModal.ActionIcon modalData={user} />
					) : (
						<BlockUserModal.ActionIcon modalData={user} />
					)}
					<DeleteUserModal.ActionIcon modalData={user} />
				</div>
			)}
		/>
		<AddUserModal />
		<EditUserModal />
		<BlockUserModal />
		<UnblockUserModal />
		<DeleteUserModal />
	</>
);
